import { pick as lodashPick, omit as lodashOmit } from "lodash";
import { EnvConfig } from "../env-config";

export const domUidGen = (function* _domUidGen() {
  for (let start = new Date().getTime(); ;) {
    yield (++start).toString(36);
  }
})();

/**
 *  uuid str test
 */
export const isUuid = str => /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(str);


/**
 * Arrray.sort with source preservation
 */
export const sort = <T>(arr: T[], comp: (a: T, b: T) => number): T[] => {
  let out = [...arr];
  out.sort(comp);
  return out;
};

export const distinct = <T>(arr: T[], fn = (a: T, b: T) => a === b): T[] => arr.reduce((out, r) => {
  if (!out.some(r2 => fn(r, r2))) {
    out.push(r);
  }
  return out;
}, []);


export const flatMap = (arr, fn = d => d) => arr.reduce((out, r) => [...out, ...fn(r)], []);
export const flatMapSome = (arr, fn = d => d) => arr.filter(Boolean).reduce((out, r) => [...out, ...fn(r)], []);

export const arrReverse = <T>(input: T[]): T[] => {
  let arr = [...input];
  arr.reverse();
  return arr;
};

export const arrayToggle = (arr, input, byOrPredicate) => {
  let output = [...arr];
  let target = output.find(typeof byOrPredicate === "function" ? byOrPredicate : _ => _[byOrPredicate] === input[byOrPredicate]);
  return target ? output.filter(_ => _ !== target) : [...output, input];
};

export const sortTextNoCase = {
  asc: (fn = (o => o)) => (a, b) => fn(a)?.toLowerCase().localeCompare(fn(b)),
  desc: (fn = (o => o)) => (a, b) => fn(b)?.toLowerCase().localeCompare(fn(a))
};

export const arrDiff = <T, U>(prev: T[], next: T[], keyFn: (r: T) => U): {removed: T[], added: T[], unchanged: T[]} => {
  return [...(next || []).reduce((out, r) => {
    out.set(keyFn(r), out.has(keyFn(r)) ? [1, r] : [2, r]);
    return out;
  }, new Map<U, [number, T]>((prev || []).map(r => [keyFn(r), [0, r]])))
    .values()].reduce((out, [v, o]) => {
    out[["removed", "unchanged", "added"][v]].push(o);
    return out;
  }, {removed: [], unchanged: [], added: []});
};

export const identity = value => value;

export const serializeQueryObj = function (obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p) && obj[p] !== undefined) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.length > 0 ? `?${str.join("&")}` : "";
}


export const FileConvertSize = aSize => {
  aSize = Math.abs(parseInt(aSize, 10));
  var def: [number, string][] = [[1, 'octets'], [1024, 'ko'], [1024 * 1024, 'Mo'], [1024 * 1024 * 1024, 'Go'], [1024 * 1024 * 1024 * 1024, 'To']];
  for (var i = 0; i < def.length; i++) {
    if (aSize < def[i][0]) return (aSize / def[i - 1][0]).toFixed(2) + ' ' + def[i - 1][1];
  }
};

export function isMobile(){
  return window.matchMedia && window.matchMedia('(max-device-width: 480px)').matches || screen.width <= 480;
}

export const pick = <T>(o: T, ...props: (keyof T | (keyof T)[])[]): Partial<T> => {
  return o && lodashPick(o, flatMap(props, a => a instanceof Array ? a : [a]));
};

export const omit = <T>(o: T, ...props: (keyof T | (keyof T)[])[]): Partial<T> => {
  return o && lodashOmit(o, flatMap(props, a => a instanceof Array ? a : [a]));
};

/**
 * Clone an object with getters & setters
 */
export function shallowClone<T>(o: T): T {
  return Object.create(
    Object.getPrototypeOf(o),
    Object.getOwnPropertyDescriptors(o)
  );
}

export const ilikeRgx = (q: string): RegExp => {
  return q?.length ?
    new RegExp(
      q.replace(/([\/\\\(\)\[\]])/g, "\\$1")
        .replace(/\-/g, "[\\-|\\s]")
        .replace(/[aáàãäâ]/ig, "[aáàãäâ]")
        .replace(/[eéèëê]/ig, "[eéèëê]")
        .replace(/[iíìïî]/ig, "[iíìïî]")
        .replace(/[oóòõöô]/ig, "[oóòõöô]")
        .replace(/[uúùüû]/ig, "[uúùüû]"),
      "ig"
    )
    :/.*/g;
};

export const andThen = (cond, fn) => cond && fn(cond);

export const getFileSrc = (fileId: string): string => {
  if (isUuid(fileId)){
      return `${EnvConfig("FILES_SERVER_URL")}/files/serve/${fileId}`
  } else {
      return `${EnvConfig("FRONT_URL")}/static/images/${fileId}`
  }
}